module.exports = __webpack_public_path__ + "static/media/miftah.b749702e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/Team/miftah.jpg
// module id = 169
// module chunks = 0